import { render, staticRenderFns } from "./Portfolio-GIS.vue?vue&type=template&id=38c172c2"
import script from "./Portfolio-GIS.vue?vue&type=script&lang=js"
export * from "./Portfolio-GIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports